import router from "../../router";

const state = {
	buildingNameNumberFilter: null,
	deptSelect: null, // department number for filter/search
	searchBuildings: null,
	building: null,
	buildingRooms: null,
	buildingRoomsFull: null,
	room: null,
	floor: null,
	// object in room.pct array
	deptSelectedIndex: 0, // index in room.pct (i.e room.pct[0])
	loadingRoomDetail: false,
	blankProgram : {
		key: null,
		percentage: 0,
		programID: null,
		name: "NEW PROGRAM"
	},

	// UI for DV
	showDVBulkEdit: false,
}

const mutations = {
	setShowDVBulkEdit(state, payload) {
		state.showDVBulkEdit = payload;
	},
	createNewRoom(state, payload) {
		console.log("CreateNewRoomPayload: ", payload)
		state.room={}
		state.room.new=true
		if (!payload) {
			state.room.bldgAlpha = state.building.bldgAlpha
		} else {
			state.room.bldgAlpha = payload.bldgAlpha
		}
		state.room.restricted = null
		state.room.dateInventory = new Date().toISOString().substr(0, 10)
	},
	setBuildingNameNumberFilter(state, payload) {
		state.buildingNameNumberFilter = payload;
	},
	setDeptSelect(state, payload) {
		state.deptSelect = payload;
	},
	setSearchBuildings(state, payload) {
		state.searchBuildings = payload;
	},
	setdvBuilding(state, payload) {
		if (state.building && payload && payload.bldgAlpha != state.building.bldgAlpha) {
			router.push({
				name: "bldgviewerToBuilding",
				params: { bldg: payload.bldgAlpha }
			});
			//console.log("Set Route ", { name: 'bldgviewerToBuilding', params: { bldg: payload.bldgAlpha }})
		}
		state.building = payload;
		state.room = null;
	},
	setdvBuildingOnly(state, payload) {
		state.building = payload;
		state.room = null;
	},
	setdvBuildingRooms(state, payload) {
		state.buildingRooms = payload;
	},
	setdvBuildingRoomsFull(state, payload) {
		state.buildingRoomsFull = payload;
	},

	

	setdvFloor(state, payload) {
		state.floor = payload;
	},

	setDeptSelectedIndex(state, payload) {
		state.deptSelectedIndex = payload;
	},

	setLoadingRoomDetail(state, payload) {
		state.loadingRoomDetail = payload;
	},

	//////////////////////////////////////////

	addBlankProgramRow(state, payload) {
		// state.room.PCT[state.deptSelectedIndex].program.push(state.blankProgram);
		// Make a shallow copy of the blank program array and add it to the state
		let newProgram = Object.assign({}, state.blankProgram)
		state.room.PCT[state.deptSelectedIndex].program.push(newProgram);
	},

	addBlankAccountRow(state, payload) {
		let blankAccount = {
			key: null,
			accountno: null,
			description: null,
			department: null,
			college: null,
			responsiblePersonID: null,
			responsiblePerson: null,
			pi: null,
			hierarchyIDS: null,
			dateUpdated: null,
			dateAdded: null,
			dateInactive: null,
			currentAccount: "Y",
			accountHigherEdFunctionCD: "IN",
			accountFederalFunctionCD: "INS",
			accountCostSubcategoryCD: "-"
		};

		state.room.PCT[state.deptSelectedIndex].program.push(blankAccount);
	}
};

const actions = {

	setRoom({state, rootState}, payload) {
		console.log("Action: setRoom", payload)
		// reset to first dept if switching rooms.
		if (!state.room || payload && (state.room && payload.number != state.room.number)) { state.deptSelectedIndex = 0 }
			

		state.room = payload	

		// Skip this route processing if we're using the roomViewer
		if (rootState.roomViewer.roomBucket) { return }	
		
		/*if (router.currentRoute.path.includes('bldgviewe ') && state.room ) {
			router.push({
				name: "bldgviewerToRoom",
				params: { bldg: state.building.bldgAlpha, room: state.room.number }
			});
		} */

		else if (router.currentRoute.path.includes('bldgviewer') && state.building) {
			router.push({
				name: "bldgviewerToBuilding",
				params: { bldg: state.building.bldgAlpha }
			});
		}
	},

	refreshBuilding ({commit, getters, dispatch, state}, bldgAlpha) {		
		commit('setdvBuildingRooms', null)
		dispatch('setRoom', null)
		commit('setdvBuildingRoomsFull', null)
		commit('setdvBuilding', null)
		commit('setdvFloor', null)

		if (bldgAlpha) {
			dispatch('fetchBuilding', bldgAlpha).then((data) => { 
				commit('setdvBuilding', data) 

				state.building.floors.length > 0 && dispatch('fetchFloor', {bldgAlpha: bldgAlpha, floor: state.building.floors[0]})
				.then((data) => commit('setdvFloor', data))
			})

		
			dispatch('fetchBuildingRooms', bldgAlpha).then((data) => { 
				if (data.Message) {
			      	console.log("Error Detected")
			      	commit('setSnackText', "Rooms failed to load")
			      	return
			    } 
			    //console.log("Setting DV BuildingRooms")
				commit('setdvBuildingRooms', data)
			})	
		}	
	},

};

const getters = {
	getDept: state => () => {
		return state.room.pct[deptSelectedIndex];
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/dv.js